var _mask, _path, _mask2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScarcity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_19489_3959",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7399 12.9178C20.7399 14.8284 20.1734 16.696 19.1119 18.2846C18.0505 19.8732 16.5418 21.1113 14.7766 21.8425C13.0115 22.5736 11.0692 22.7649 9.19535 22.3922C7.32149 22.0195 5.60025 21.0994 4.24927 19.7485C2.8983 18.3975 1.97827 16.6762 1.60554 14.8024C1.2328 12.9285 1.4241 10.9862 2.15525 9.22109C2.88639 7.45596 4.12453 5.94727 5.71311 4.88582C7.30169 3.82436 9.16935 3.25781 11.0799 3.25781V12.9178H20.7399Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7399 12.9178C20.7399 14.8284 20.1734 16.696 19.1119 18.2846C18.0505 19.8732 16.5418 21.1113 14.7766 21.8425C13.0115 22.5736 11.0692 22.7649 9.19535 22.3922C7.32149 22.0195 5.60025 21.0994 4.24927 19.7485C2.8983 18.3975 1.97827 16.6762 1.60554 14.8024C1.2328 12.9285 1.4241 10.9862 2.15525 9.22109C2.88639 7.45596 4.12453 5.94727 5.71311 4.88582C7.30169 3.82436 9.16935 3.25781 11.0799 3.25781V12.9178H20.7399Z",
    stroke: "currentColor",
    strokeWidth: 1.84,
    mask: "url(#path-1-inside-1_19489_3959)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_19489_3959",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C13.5102 0.5 15.0056 0.797456 16.4009 1.37539C17.7961 1.95331 19.0639 2.8004 20.1317 3.86827C21.1996 4.93615 22.0467 6.2039 22.6246 7.59914C23.2025 8.99439 23.5 10.4898 23.5 12L12 12V0.5Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C13.5102 0.5 15.0056 0.797456 16.4009 1.37539C17.7961 1.95331 19.0639 2.8004 20.1317 3.86827C21.1996 4.93615 22.0467 6.2039 22.6246 7.59914C23.2025 8.99439 23.5 10.4898 23.5 12L12 12V0.5Z",
    stroke: "currentColor",
    strokeWidth: 1.84,
    mask: "url(#path-2-inside-2_19489_3959)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScarcity);
export default __webpack_public_path__ + "static/media/scarcity.f788008fdb56488a3092ce6bf8981574.svg";
export { ForwardRef as ReactComponent };